import * as yup from "yup";

export default function schema() {
    const schema = yup.object({
        sesame1: yup.string().required('Please Enter your password')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                "Must contain eight characters, one uppercase, one lowercase, one number and one special case character"),
        sesame2: yup.string().oneOf([yup.ref('sesame1'), null], 'Passwords must match')
    });
    return schema;
}
